import {observable, action, runInAction, computed} from 'mobx'
//import {message} from 'antd'
import {get, json} from '../../../utils/ajax'
import {handleSeerchAndPage} from "../../../utils/Utils";

class verificationStore {
    @observable loading
    @observable page
    @observable pagination
    @observable nineList//九大类
    @observable mainList//主组
    @observable mainPictureList//主组的图
    @observable picture//单张图片
    @observable groupList//分组
    @observable carsysId//整个页面车系id
    @observable epcSearchList//右侧表格
    @observable initCondition
    @observable searchFields
    @observable epcList//底部epc表格
    @observable carseriesName//车系名称
    @observable detialinfo//详情
    @observable state
    @observable coordinateList
    @observable modal
    @observable sparePartFields//零件详细信息

    constructor() {
        this.modal='hide'
        this.loading = false
        this.carsysId = ''
        this.coordinateList = []
        this.carseriesName = ''
        this.picture = ''
        this.state = '0'
        this.nineList = []
        this.mainList = []
        this.mainPictureList = []
        this.groupList = []
        this.epcSearchList = []
        this.epcList = []
        this.searchFields = {
            sparepName: '',
            sparepNo: '',
            materialCode: ''
        }
        this.initCondition = {
            carseriesId: '',
            catalogId: ''
        }
        this.page = {
            current: 0,
            total: 1
        }
        this.pagination = {
            current: 0,
            total: 1
        }
        this.detialinfo = {
            name: '',
            code: '',
            description: '',

            sparepNo: '',
            sparepName: '',
            materialCode: '',
            remarks: ''
        }
        this.emptysparePartFields()
    }
   //零件详细信息初值
    emptysparePartFields() {
        this.sparePartFields = {
            //技术属性
            id: '',
            materialCode:'',
            sparepName: '',
            sparepNo: '',
            specifications: ' ',// 规格型号
            material: ' ',// 材质
            volume: ' ',// 体积
            weight: ' ',// 重量
            statutes: ' ',// 法规件(1.3C件2.关重件3.非关重件)
            designLife: ' ',// 设计寿命
            color: ' ',// 颜色
            technicalRequirement: ' ',// 技术要求
            lifeCycle: ' ',// 生命周期
            sparepSource: ' ',// 数据来源(1.Ebom2.Mbom3.售后市场)
            dataSource: ' ',//备件来源(1.国外2.自制3.外采)
            sparepType: ' ',// 备件类型(所有1.日常保养件 2.易损件 3.事故件 4.其他)
            sparepStatus: ' ',// 备件状态(所有 1.在用 2.停产 4.取消 4.替换 5.其他 6.停用7.启用)
            manufacturer: ' ',// 供应商
            manufacturerCode: ' ',// 供应商代码
            remarks: '',//备注
            //销售属性
            //目录属性
            //仓储属性
            storageState:'',
            deliveryWay: '',
            isDanger: '',
            isValuables: '',
            isFragile: '',
            isAntirust: '',
            warrantyTime: '',
            //订货属性
            orderState:'',
            buyWay:'',
            packageContent:'',
            orderMarked:'',
            //备件图片
        }
    }
    @computed
    get fields() {
        let fields = {
            //技术属性
            id: {value: this.sparePartFields.id},
            materialCode: {value: this.sparePartFields.materialCode},
            sparepNo: {value: this.sparePartFields.sparepNo},
            sparepName: {value: this.sparePartFields.sparepName},
            specifications: {value: this.sparePartFields.specifications},
            material: {value: this.sparePartFields.material},
            volume: {value: this.sparePartFields.volume},
            weight: {value: this.sparePartFields.weight},
            statutes: {value: this.sparePartFields.statutes},
            designLife: {value: this.sparePartFields.designLife},
            color: {value: this.sparePartFields.color},
            technicalRequirement: {value: this.sparePartFields.technicalRequirement},
            lifeCycle: {value: this.sparePartFields.lifeCycle},
            sparepSource: {value: this.sparePartFields.sparepSource},
            dataSource: {value: this.sparePartFields.dataSource},
            sparepType: {value: this.sparePartFields.sparepType},
            sparepStatus: {value: this.sparePartFields.sparepStatus},
            manufacturer: {value: this.sparePartFields.manufacturer},
            manufacturerCode: {value: this.sparePartFields.manufacturerCode},
            remarks: {value: this.sparePartFields.remarks},
            //销售属性
            //目录属性
            //仓储属性
            storageState: {value: this.sparePartFields.storageState},
            deliveryWay: {value: this.sparePartFields.deliveryWay},
            isDanger: {value: this.sparePartFields.isDanger},
            isValuables: {value: this.sparePartFields.isValuables},
            isFragile: {value: this.sparePartFields.isFragile},
            isAntirust: {value: this.sparePartFields.isAntirust},
            warrantyTime: {value: this.sparePartFields.warrantyTime},
            //订货属性
            buyWay: {value: this.sparePartFields.buyWay},
            packageContent: {value: this.sparePartFields.packageContent},
            orderMarked: {value: this.sparePartFields.orderMarked},
            orderState: {value: this.sparePartFields.orderState},
        }
        return fields;
    }


    @action setDistance = (x, y) => {
        let temp = {
            x: x,
            y: y
        }
        runInAction(() => {
            this.coordinateList.push(temp)
        })
    }
    @action empetyepcList = () => {
        runInAction(() => {
                this.epcList = []
            }
        )
    }
    @action empetyepcSearchList = () => {
        runInAction(() => {
                this.epcSearchList = []
            }
        )
    }

    @action empetyMain = () => {
        runInAction(() => {
                this.mainList = []
            }
        )
    }
    @action empetyGroup = () => {
        runInAction(() => {
                this.groupList = []
            }
        )
    }

    @action getCarseriesId = (id) => {
        runInAction(() => {
                this.carsysId = id
            }
        )
    }

    /**
     * 初始化页面，查出9大类和主组//（主组图）
     * @returns {Promise<void>}
     */
    @action
    initPage = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${0}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        const cId = res[0].id
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${cId}`)
        if (res1 && res1.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogphoto/carseriesId/${this.carsysId}/catalogId/${cId}`)
        if (res2 && res2.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        const res3 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/carseriesCatalog/${this.carsysId}`)
        if (res3 && res3.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        runInAction(() => {
            this.nineList = res
            this.mainList = res1
            this.mainPictureList = res2
            this.carseriesName = res3.carseriesName
            this.loading = false
        })
    }

    /**
     * 点击9大类查主组
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getMain = async (key) => {
        runInAction(() => {
            this.loading = true
            this.picture = ''
            this.groupList = []
            this.epcList = []
            this.state = '0'
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${key}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogphoto/carseriesId/${this.carsysId}/catalogId/${key}`)
        if (res2 && res2.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.mainList = res
            this.mainPictureList = res2
        })
    }
    /**
     * 点击主组查分组
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getGroup = async (pid) => {
        runInAction(() => {
            this.loading = true
            this.picture = ''
            this.state = '0'
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${pid}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.groupList = res
        })
    }

    @action
    getoneGroup = async (id) => {
        runInAction(() => {
            this.loading = true
        })

        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/onecatalog/${id}`)
        if (res1 && res1.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.groupList = res1
        })
    }

    /**
     * 点击分组查备件
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getEpc = async (pid, page) => {
        runInAction(() => {
            this.loading = true
        })
        this.initCondition.catalogId = pid
        this.initCondition.carseriesId = this.carsysId
        let search = handleSeerchAndPage(page, this.pagination, this.initCondition)
        search.size = 80
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc_sparepart/gethotpoint:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.epcList = res.content || []
        })
    }

    @action
    showCatalogDetial = (record) => {
        this.state = '1'

        this.detialinfo = {
            code: record.code,
            description: record.description,
            name: record.name
        }

    }

    @action
    showCatalogSparepartDetial = (record) => {
        this.state = '2'
        this.detialinfo = {
            sparepName: record.sparepName,
            sparepNo: record.sparepNo,
            materialCode: record.materialCode,
            remarks: record.remarks
        }

    }

    /**
     * 表单查询条件改变
     * @param changedFields
     */
    @action
    searchFieldChange = (changedFields) => {
        runInAction(() => {
            this.searchFields = {
                sparepName: changedFields.sparepName ? changedFields.sparepName.value : this.searchFields.sparepName,
                sparepNo: changedFields.sparepNo ? changedFields.sparepNo.value : this.searchFields.sparepNo,
                materialCode: changedFields.materialCode ? changedFields.materialCode.value : this.searchFields.materialCode,
            }
        })
    }

    /**
     * 点击分组查备件
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getSearchEpc = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc_sparepart/gethotpoint:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.epcSearchList = res.content || []
        })
    }

    /**
     * 显示图片
     * @returns {Promise<void>}
     */
    @action
    showPicture = async (catalogId, code) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogPhoto/carseriesId/${this.carsysId}/catalogId/${catalogId}/figureNo/${code}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.picture = res.picture
        })

    }
    /**
     * 回显单条记录的热点到图上
     * @param coordinate
     * @returns {Promise<void>}
     */
    @action
    showhotpoint = async (coordinates) => {
        runInAction(() => {
            this.coordinateList = coordinates
        })
    }

    /**
     * 控制弹框modal
     * @param record
     * @returns {Promise<void>}
     */
    // @action
    // showModal = async (clear) => {
    //     runInAction(() => {
    //         this.loading = true
    //         if (clear === true) {
    //             this.emptysparePartFields()
    //         }
    //         this.modal = 'show'
    //         this.loading = false
    //     })
    // }
    /**
     * 关闭维护弹框model
     */
    @action
    close = () => {
        this.modal = 'hide'
    }

    /**
     * 显示零件详情
     * @returns {Promise<void>}
     */
    @action
    showSparepartDetial = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/get_sparepart_by_id/${id}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.sparePartFields=res
            this.modal='show'
        })
    }

}

export default new verificationStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/Verification/store.js